import { Constants } from '../_constants/shared.constants';
const initialState = { loaderValue: true };
function loaderReducer(state = initialState, action) {
  switch (action.type) {
    case Constants.loader.LOADER_REQUESTER:
      return {
        ...state,
        loaderValue: action.data,
      };
    default:
      return state
  }
}
export default loaderReducer;